import React from 'react';
import { BadgeCheck, ShieldCheck, Leaf, Users } from 'lucide-react';
import { engagementsData } from '../data/mock';

const iconMap = {
  BadgeCheck: BadgeCheck,
  ShieldCheck: ShieldCheck,
  Leaf: Leaf,
  Users: Users,
};

const EngagementsSection = () => {
  return (
    <section id="engagements" className="py-24 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-500/20 rounded-full mb-6">
            <span className="text-sm font-medium text-orange-400">Nos Engagements</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            Excellence, Sécurité, Responsabilité
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Des engagements forts pour un développement durable et responsable
          </p>
        </div>

        {/* Engagements Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {engagementsData.map((engagement, index) => {
            const IconComponent = iconMap[engagement.icon];
            return (
              <div
                key={index}
                className="group bg-slate-800/50 backdrop-blur-sm rounded-2xl p-6 hover:bg-slate-800 transition-all duration-300 border border-slate-700 hover:border-orange-500/50"
              >
                <div className="w-14 h-14 bg-orange-500/20 group-hover:bg-orange-500 rounded-xl flex items-center justify-center mb-5 transition-colors duration-300">
                  <IconComponent className="w-7 h-7 text-orange-400 group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold mb-3">{engagement.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">
                  {engagement.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Certifications Bar */}
        <div className="mt-16 bg-slate-800/50 rounded-2xl p-8 border border-slate-700">
          <div className="flex flex-wrap items-center justify-center gap-8">
            <div className="text-center">
              <div className="text-2xl font-bold text-orange-400">ISO 9001</div>
              <div className="text-sm text-slate-500">Qualité</div>
            </div>
            <div className="w-px h-10 bg-slate-700 hidden sm:block" />
            <div className="text-center">
              <div className="text-2xl font-bold text-orange-400">ISO 14001</div>
              <div className="text-sm text-slate-500">Environnement</div>
            </div>
            <div className="w-px h-10 bg-slate-700 hidden sm:block" />
            <div className="text-center">
              <div className="text-2xl font-bold text-orange-400">ISO 45001</div>
              <div className="text-sm text-slate-500">Sécurité</div>
            </div>
            <div className="w-px h-10 bg-slate-700 hidden sm:block" />
            <div className="text-center">
              <div className="text-2xl font-bold text-orange-400">BIVAC</div>
              <div className="text-sm text-slate-500">Certifié</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EngagementsSection;
